import { xGetFromToIndex } from "../x/index.js";
import { xyCheck } from "./xyCheck.js";
/**
 * Finds the max y value in a range and return a {x,y} point
 * @param data - object that contains property x (an ordered increasing array) and y (an array).
 * @param options - options.
 * @returns point with the highest y value in the range.
 */
export function xyMaxYPoint(data, options = {}) {
    xyCheck(data, { minLength: 1 });
    const { x, y } = data;
    if (x.length === 1) {
        return { x: x[0], y: y[0], index: 0 };
    }
    const { fromIndex, toIndex } = xGetFromToIndex(x, options);
    let current = { x: x[fromIndex], y: y[fromIndex], index: fromIndex };
    for (let i = fromIndex + 1; i <= toIndex; i++) {
        if (y[i] > current.y)
            current = { x: x[i], y: y[i], index: i };
    }
    return current;
}
//# sourceMappingURL=xyMaxYPoint.js.map